// removed by extract-text-webpack-plugin
module.exports = {"screenWrapper":"purify_OilSettings__screenWrapper___2IrkU"};


//////////////////
// WEBPACK FOOTER
// ./src/screens/shared/Settings/OilSettings/OilSettings.scss
// module id = 221
// module chunks = 0